import { z } from 'zod';

import { CodesResultSchema } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

type CodesResult = z.infer<typeof CodesResultSchema>;

export const retrieveCodes = async (code: string | string[], search: string, locale = 'en', system: string | string[] = undefined) => {
  try {
    const { codes }: CodesResult = await request({
      path: `settings/get-codes`,
      method: 'POST',
      authenticate: true,
      dataObject: {
        locale: locale.toLowerCase(),
        code,
        search,
        system,
      },
    });

    return codes;
  } catch (error) {
    showErrorToast(error, 'Error fetching the codes!');
  }
};
